import { generateAuthHeader } from "../../commonfunctions/authentication";
import { TransactionType, IGetTransactions, TransactionResponseTypes } from "./types";

export default async function getTransactions(
  transactionType: TransactionType,
  startDate: string,
  endDate: string,
): Promise<IGetTransactions> {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/current_customer/transactions?type=${transactionType}&start_date=${startDate}&end_date=${endDate}`,
      generateAuthHeader(),
    );

    const data = await res.json();

    if (res.ok && data.status === "success") {
      return {
        type: TransactionResponseTypes.SUCCESS,
        transactions: data.result?.transactions || [],
      };
    }

    // Handle error responses - return a simple, user-friendly message
    return {
      type: TransactionResponseTypes.FAIL,
      message: "No transactions found for the selected date range and filters.",
    };
  } catch (error) {
    return {
      type: TransactionResponseTypes.FAIL,
      message: "Failed to load Transactions",
    };
  }
}
